exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-label-toggle-component:hover{text-decoration:underline}", ""]);

// exports
